import { Div, PasswordInput } from "@tblabs/truffle";
import { Page } from "./Page";
import { PrimaryButton } from "../Components/PrimaryButton";
import { Center } from "../Components/Center";
import { InfoBox } from "../Components/InfoBox";
import { LoginFormLogic } from "../Services/Auth/LoginFormLogic";


export class LoginPage extends Page
{
    constructor(private _formLogic: LoginFormLogic)
    {
        super("Logowanie");
    }

    protected async OnAppend(): Promise<void>
    {
        const passwordInput = new PasswordInput(this._formLogic.PasswordInput).ShowPasswordOnTouch()
            .Placeholder("Hasło")
            .OnEnterKeyPressed(async () => await this._formLogic.TryLogin())

        const loginButton = new PrimaryButton("Zaloguj")
            .Disable(this._formLogic.LoginInProgress)
            .OnClick(async () => await this._formLogic.TryLogin())

        this.body.MaxWidth(600).Append(
            new Div().Style(`padding-top: 64px; display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 8px;`).Append(
                passwordInput,
                loginButton,
            ),
            new Center(
                new InfoBox("Błąd", this._formLogic.ErrorMessage)
                    .Visible(this._formLogic.ErrorMessageVisible)
            )
        );
    }
}